export enum SectorEnum {
  NONE = 0,
  ADMINISTRADOR = 1,
  ENGENHARIA_DE_SOFTWARE = 2,
  FINANCEIRO = 3,
  GESTAO = 4,
  MARKETING = 5,
  OUTRO = 6,
  CEO = 7  
}